import { render } from "./ProductManage.vue?vue&type=template&id=9cba4f94&scoped=true"
import script from "./ProductManage.vue?vue&type=script&lang=js"
export * from "./ProductManage.vue?vue&type=script&lang=js"

import "./ProductManage.vue?vue&type=style&index=0&id=9cba4f94&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cba4f94"]])

export default __exports__